import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  lastItem: {
    color: theme.palette.primary.main,
    paddingLeft: '0.5rem',
  },
}));
